import { differenceInSeconds, parseISO } from "date-fns";
import { formatTimeAgo } from "@src/utils/format-date";

interface SnapshotChipData {
  chipLabel: string;
  showSnapshotChip: boolean;
}

export function getSnapshotChipData(
  snapshotCapturedAt: string | null | undefined,
  isOnline: boolean,
): SnapshotChipData {
  if (!snapshotCapturedAt) {
    return {
      chipLabel: isOnline ? "Live" : "Offline",
      showSnapshotChip: true,
    };
  }

  try {
    const date = parseISO(snapshotCapturedAt);
    const ageSeconds = Math.max(0, differenceInSeconds(new Date(), date));

    return {
      chipLabel: formatTimeAgo(date),
      showSnapshotChip: ageSeconds >= 60,
    };
  } catch {
    return {
      chipLabel: isOnline ? "Live" : "Offline",
      showSnapshotChip: true,
    };
  }
}
